import React from 'react'
import TagInput from "../../TagInput"
import Button from "../../Button"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinnerThird} from "@awesome.me/kit-a13c95776b/icons/modules/classic/thin";

export const AdvancedSettingsSection = ({
  isAdvanced,
  onEnableAdvanced,
  tags,
  inputId,
  placeholder,
  description,
  onSave,
  advDescId,
  copy = false,
  showIcon
}) => {
  if (isAdvanced) {
    return (
      <>
        <div className="ml-4 mt-3 collapse show" />
        <div className="row languages-select">
          <div className="col-12">
            <TagInput
              name={`page[${inputId}]`}
              tags={tags}
              inputId={inputId}
              placeholder={placeholder}
              copy={copy}
            />

            <div className="d-flex justify-content-between mt-1 mb-4">
              <div className="sent-text-extra">
                {description}
              </div>
              <div className='ml-2'>
                <Button name="button" className="btn btn-primary save-blacklist" clickHandler={onSave}>
                  Save
                  {showIcon && <FontAwesomeIcon icon={faSpinnerThird} className="ms-2" spin={true}/>}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <div className="row languages-select my-2">
      <a
        href="#"
        className="fs-08"
        onClick={onEnableAdvanced}
      >
        Advanced settings (by default we hide all {advDescId})
      </a>
    </div>
  )
} 